export default __webpack_public_path__ + "static/media/PancakeRocks.0fab67e3.jpg";